import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { DocPresenterDetails } from 'src/app/ViewModel/PeerReviewModel';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { CommonService } from 'src/app/Service/Common.service';
import {  FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { ExcelExportEvent } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { orderBy } from 'lodash';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';


@Component({
  selector: 'app-review-view',
  templateUrl: './review-view.component.html',
  styleUrls: ['./review-view.component.css']
})
export class ReviewViewComponent implements OnInit {

  public dataView: any[] = [];
  public gridData: any[] = [];
  public docDetails: any[] = [];
  public docflow: any[] = [];
  public presenterdata: DocPresenterDetails[] = [];
  public location: string | null = null;
  public panel: any[] = [];
  public cri: any[] = [];
  public enableFilter : boolean = false;
  public isProjectOverviewAvailable: boolean = false;
  public isChecklistAvailable: boolean = false;


  public grid2: any[] = [];
  public input;

  constructor(private dialog: MatDialog,private _fileService: FileService, private _peerReviewService: PeerReviewService, private commonService: CommonService, public _dialogRef: MatDialogRef<ReviewViewComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.docDetails = this.data.docvalue;
      this.input = this.data.input;
    }
  }

  ngOnInit() {
    this.getProjectFiles('0');
    this.getProjectFiles('1');
    this.gridData.push({
      doc_no: this.docDetails[0].doc_no,
      review_type: this.docDetails[0].review_type,
      peer_review_refno: this.docDetails[0].peer_review_refno,
      review_date: this.docDetails[0].review_date,
      review_from_time: this.docDetails[0].review_from_time,
      review_upto_time: this.docDetails[0].review_upto_time,
      project_description: this.docDetails[0].project_description,
      document_status: this.docDetails[0].document_status,
      scope_of_review: this.docDetails[0].scope_of_review,
      services_included: this.docDetails[0].services_included,
      required_documents: this.docDetails[0].required_documents,
      type_of_structure: this.docDetails[0].type_of_structure,
      stages_of_review: this.docDetails[0].stages_of_review,
      document_location: this.docDetails[0].document_location,
      vc_required: this.docDetails[0].vc_required == "Yes" ? "Required" : "Not Required",
      ecd_for_project: this.docDetails[0].ecd_for_project,
      mep_ecd_for_project: this.docDetails[0].mep_ecd_for_project,
      decd_for_project: this.docDetails[0].decd_for_project,
      project_name: this.docDetails[0].project_name,
      project_code: this.docDetails[0].project_code,
      building_type: this.docDetails[0].building_type,
      client_name: this.docDetails[0].client_name,
      project_value_in_lakhs: this.docDetails[0].project_value_in_lakhs,
      design_fee_in_lakhs: this.docDetails[0].design_fee_in_lakhs,
      project_brief_desc: this.docDetails[0].project_brief_desc,
      nature_of_project: this.docDetails[0].nature_of_project,
      contract_type: this.docDetails[0].contract_type,
      project_scope_of_work: this.docDetails[0].project_scope_of_work,
      built_up_area_in_sqm: this.docDetails[0].built_up_area_in_sqm,
      plot_area_in_sqm: this.docDetails[0].plot_area_in_sqm,
      proof_consultant_name: this.docDetails[0].proof_consultant_name,
      architectural_consultant_name: this.docDetails[0].architectural_consultant_name,
      structural_consultant_name: this.docDetails[0].structural_consultant_name,
      any_other_consultants: this.docDetails[0].any_other_consultants,
      project_start_date: this.docDetails[0].project_start_date,
      project_end_date: this.docDetails[0].project_end_date,
      project_submission_date: this.docDetails[0].project_submission_date,
      date_of_loi: this.docDetails[0].date_of_loi,
      edms_available: this.docDetails[0].edms_available == "Yes" ? "Available" : "Not Available",
      scope_for_peer_review: this.docDetails[0].scope_for_peer_review,
      created_by: this.docDetails[0].created_by,
      created_on: this.docDetails[0].created_on,
      approved_by: this.docDetails[0].approved_by,
      approved_on: this.docDetails[0].approved_on,
      comments_status: this.docDetails[0].comments_status,
      response_status: this.docDetails[0].response_status,
      impact_status: this.docDetails[0].impact_status,
      ds_code: this.docDetails[0].ds_code
    });

    this._peerReviewService.getPeerDocFlow(this.input).subscribe((resDocflow)=>
    {
      this.docflow = resDocflow;
    });
    this._peerReviewService.getPeerPresenter(this.input).subscribe((resPresenter)=>
    {
      this.presenterdata = resPresenter;
    });
    this._peerReviewService.getPeerPanelMembers(this.input).subscribe((resPanel)=>
    {
      this.panel = orderBy(resPanel,['member_Discipline','member_Name']);
      if(this.panel[0].location_name)
        this.location = this.panel[0].location_name;
    });
    this._peerReviewService.getPeerCRI(this.input).subscribe((resCRI)=>
    {
      this.cri = resCRI;
    });
    this.allData = this.allData.bind(this);
  }

  public viewCommentsAttachmentClick(dataItem: any) 
  {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary',  'w100'],
      data: { projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRC', libraryName: FileUploadLibrary.WorkflowDocument, 
          createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: false },
    });
  }

  public viewImpactsAttachmentClick(dataItem: any) 
  {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary',  'w100'],
      data: { projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRI', libraryName: FileUploadLibrary.WorkflowDocument, 
          createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: false },
    });
  }

  closeDialog() {
    this._dialogRef.close();
  }

  openFile(revisionNo:string)
  {
    let id = this.commonService.getProjectId()+'001'
    if(revisionNo=='1')
    {
      let value:string[] = this.docDetails[0]?.peer_review_refno?.split('-');
      let peerDocno = value[1].substring(2,value[1].length);
      id = this.docDetails[0]?.intProjectId + peerDocno;
    }

    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary',  'w100'],
      data: { projectId: this.commonService.getProjectId(), docId: id, revisionNo: revisionNo, libraryName: FileUploadLibrary.WorkflowDocument, 
          createdBy: this.commonService.getLoggedInUserId(), isDeleteEnable: false },
    });
  }
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.cri.map((x,indx) => 
      ({
        ...x,
        Sl_No:indx+1,
        commented_By: x.commented_By ? x.commented_By + ` - ${x.commented_On ? moment(x.commented_On).format('DD-MMM-yyyy') : ''}` : '',
        response_Received_From : x.response_Received_From ? x.response_Received_From + ` - ${x.response_Received_On ? moment(x.response_Received_On).format('DD-MM-YYYY'): ''}` : '',
        project_Design_Team_Response : x.project_Design_Team_Response ? x.project_Design_Team_Response == 'Comply' ? x.project_Design_Team_Response + ` (Action) - ${x.response_Remarks ? x.response_Remarks:''}` : x.project_Design_Team_Response + ` (Reason) - ${x.disAgree_Reason_Remarks
        ? x.disAgree_Reason_Remarks:''}`:'',
        response_Entry_Done_By: x.response_Entry_Done_By ? x.response_Entry_Done_By + ` - ${x.response_Entry_Done_On ? moment(x.response_Entry_Done_On).format('DD-MM-YYYY'):''}`:'',
        comment_Category: x.comment_Category ? x.comment_Category : '',
        potential_Comment: x.potential_Comment ? x.potential_Comment + `.${x.comment_Category ? x.comment_Category : ''}` : ''
      }))
    }
    return result;
  }
  public onExcelExport(e: ExcelExportEvent): void {
    e.workbook.sheets[0].columns.forEach((data: { width: number; autoWidth: boolean; textAlign: string; }, i) => {
      if(i==0 || i==1 )
      {
        data.width = 30;
        data.autoWidth = true;
      }
      else
      {
        data.width = 300;
        data.autoWidth =false;
      }
    })
    let values = e.workbook.sheets[0].rows;
    values[0].height = 50;
    values[0].cells[5].wrap = true;
    for (let i = 0; i < e.workbook.sheets[0].columns.length; i++) {
      values[0].cells[i].background = '#507bd1'
      values[0].cells[i].color = "#ffffff"
      values[0].cells[i].textAlign = "center"
      values[0].cells[i].verticalAlign = "center"
      values[0].cells[i].wrap = true;
    }

    for(let i=1;i<e.workbook.sheets[0].rows.length;i++)
    {
      var len1 = values[i].cells[3].value && values[i].cells[3].value.length ? values[i].cells[3].value.length : 0
      var len2 = values[i].cells[6].value && values[i].cells[6].value.length ? values[i].cells[6].value.length : 0
      var len3 = values[i].cells[8].value && values[i].cells[8].value.length ? values[i].cells[8].value.length : 0
      var maxlength = Math.max(len1, len2, len3)
      if ((len1 > 250) || (len2 > 250) || (len3 > 250)) {
        values[i].height = (maxlength / 3) * 1.75;
        values[i].cells[3].wrap = true;
        values[i].cells[6].wrap = true;
        values[i].cells[8].wrap = true;
      }
      else if((len1 > 100 && len1 < 250) || (len2 > 100 && len2 < 250) || (len3 > 100 && len3 < 250))
      {
        values[i].height = (maxlength / 4) * 1.75;
        values[i].cells[3].wrap = true;
        values[i].cells[6].wrap = true;
        values[i].cells[8].wrap = true;
      }
      else if ((len1 < 100 && len1 > 50) || (len2 < 100 && len2 > 50) || (len3 < 100 && len3 > 50)) {
        values[i].height = (maxlength / 2) * 2.25;
        values[i].cells[3].wrap = true;
        values[i].cells[6].wrap = true;
        values[i].cells[8].wrap = true;
      }
      else {
        values[i].height = maxlength < 30 ? 20 : maxlength;
        values[i].cells[3].wrap = true;
        values[i].cells[6].wrap = true;
        values[i].cells[8].wrap = true;
      }
  
      let category:string = values[i].cells[4].value
      let categoryValue = category.split('.')[1];
      values[i].cells[4].value = category.split('.')[0];
      if (categoryValue == 'High Risk') { values[i].cells[4].background = '#ff0000'; values[i].cells[4].color = "#fff"; values[i].cells[4].bold = true; values[i].cells[4].verticalAlign = "top" }
      if (categoryValue == 'Medium Risk') { values[i].cells[4].background = '#ffbf00'; values[i].cells[4].color = "#fff"; values[i].cells[4].bold = true; values[i].cells[4].verticalAlign = "top" }
      if (categoryValue == 'Low Risk') { values[i].cells[4].background = '#007800'; values[i].cells[4].color = "#fff"; values[i].cells[4].bold = true; values[i].cells[4].verticalAlign = "top" }
    }
    for (var i = 1; i < values.length; i++) {
      for (var j = 0; j < e.workbook.sheets[0].columns.length; j++) {
        if (j == 0 || j == 1 || j==2 || j==7) {
          values[i].cells[j].textAlign = "center";
          values[i].cells[j].verticalAlign = "center"
        }
        else {
          values[i].cells[j].textAlign = "left"
          values[i].cells[j].verticalAlign = "top"
        }
        if (i != 0 && j != 4) {
          values[i].cells[j].background = (i + 1) % 2 ? '#eff3fb' : '#ffffff';
        }
        values[i].cells[j].borderTop = { color: '#000', size: 1 };
        values[i].cells[j].borderBottom = { color: '#000', size: 1 };
        values[i].cells[j].borderLeft = { color: '#000', size: 1 };
        values[i].cells[j].borderRight = { color: '#000', size: 1 };

      }
    }
    for(var i=0;i<1;i++)
    {
      for(var j=0;j<e.workbook.sheets[0].columns.length;j++)
      {
        values[i].cells[j].borderTop = { color: '#000', size: 1 };
        values[i].cells[j].borderBottom = { color: '#000', size: 1 };
        values[i].cells[j].borderLeft = { color: '#000', size: 1 };
        values[i].cells[j].borderRight = { color: '#000', size: 1 };
      }
    }
  }

  uploadPeerReviewChecklist()
  {
    let id = Number(this.docDetails[0].peer_review_refno.split('-')[1]?.substring(2,this.docDetails[0].peer_review_refno.split('-')[1]?.lenght));
    let uniqueProjectId = this.commonService.getProjectId().toString() + id.toString()
    const dialog = this.dialog.open( FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '80%',
      data: { projectId: this.commonService.getProjectId(), docId: uniqueProjectId, revisionNo: '1', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
          createdBy: this.commonService.getLoggedInUserId(), 
          documents: [{ value: uniqueProjectId, text: 'prAdequacyCheckList', revisionNo: '1',  task_SNo: 0 }],
          isEditable: false,isEnableFullScreen:true },
    });
    // dialog.componentInstance.onUploadFinished.subscribe(res => {
    //   let fileName: string = res.fileName;
    //   let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
    //   this.attachmentsList.push({ fileId: -1, fileName: fileName.substring(0, fileName.lastIndexOf(".")), fileExtension: fileExtn, fileSize: res.fileSize });
    // });
    dialog.afterClosed().subscribe(()=>{
      this.getProjectFiles('1');
    })
  }

  uploadProjectOverview()
  {
    let uniqueProjectId = '00'+this.commonService.getProjectId()+'001';
    const dialog = this.dialog.open( FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '80%',
      data: { projectId: this.commonService.getProjectId(), docId: uniqueProjectId, revisionNo: '0', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
          createdBy: this.commonService.getLoggedInUserId, 
          documents: [{ value: uniqueProjectId, text: 'ProjectOverview', revisionNo: '0',  task_SNo: 0 }],
          isEditable: false,isEnableFullScreen:true },
    });

    dialog.afterClosed().subscribe(()=>{
      this.getProjectFiles('0');
    })
  }

  getProjectFiles(revisionNo:string)
  {
    let id = Number(this.docDetails[0].peer_review_refno.split('-')[1]?.substring(2,this.docDetails[0].peer_review_refno.split('-')[1]?.lenght));
    let uniqueId = (this.commonService.getProjectId()) + (revisionNo == '0' ? '001' : id.toString());

    this._fileService.GetFiles({libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(
      { projectId: this.commonService.getProjectId(), docId: Number(uniqueId), revisionNo: revisionNo })}).subscribe((res:any)=>{
        if(revisionNo=='0')
        {
          this.isProjectOverviewAvailable = res && res.length>0 ? true:false
        }
        if(revisionNo=='1')
        {
          this.isChecklistAvailable = res && res.length>0 ? true:false;
        }
      })
  }

  
  
}


